import React from 'react';
import Modal, { MODAL_WELL } from './Modal';
import Button from './Button';
import brandConversionService from '../services/brandConversionService';

/**
 * Modal opened when a guest taps a `PartyPatronGiftReceived` notification.
 * Shows: brand logo, brand name, custom message, the $ amount that landed in their Wallet,
 * and two CTAs — Browse Events (back to FeaturedWall) and Redeem Code (to brand's link).
 */
export default function PatronGiftCard({
  isOpen,
  onClose,
  brandId,
  partyPatronId,
  brandName,
  brandLogoUrl,
  message,
  giftAmountCents = 0,
  promoLink,
  promoCode,
  onBrowseEvents,
}) {
  if (!isOpen) return null;
  const dollars = (giftAmountCents / 100).toFixed(2);

  const handlePromoClick = () => {
    if (brandId) {
      brandConversionService.logPromoClicked(brandId, { partyPatronId }).catch(() => {});
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="">
      <div className="font-mono text-sm space-y-4 text-center">
        <p className="text-3xl">🎉</p>
        <p className="text-lg font-bold uppercase tracking-wider">You've been gifted ${dollars}</p>
        {brandLogoUrl ? (
          <img src={brandLogoUrl} alt={brandName} className="mx-auto h-16 object-contain" />
        ) : (
          <div className="mx-auto h-16 flex items-center justify-center font-mono text-xs uppercase">{brandName}</div>
        )}
        <p className="font-mono text-xs uppercase tracking-wider text-gray-500">From today's Party Patron:</p>
        <p className="font-mono text-base font-bold uppercase tracking-wider">{brandName}</p>

        {message && (
          <div className={`${MODAL_WELL} text-left`}>
            <p className="font-mono text-xs italic text-gray-700">"{message}"</p>
            {promoCode && (
              <p className="font-mono text-[10px] uppercase tracking-wider mt-2">
                CODE: <span className="font-bold">{promoCode}</span>
              </p>
            )}
          </div>
        )}

        <p className="font-mono text-xs">${dollars} added to your Wallet.</p>

        <div className="flex gap-2 pt-2">
          <Button onClick={onBrowseEvents} variant="primary" className="flex-1">BROWSE EVENTS</Button>
          {promoLink && (
            <a
              href={promoLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handlePromoClick}
              className="flex-1 inline-flex min-h-[46px] items-center justify-center rounded-full bg-[#F2F2F2] px-5 font-mono text-[11px] font-bold uppercase tracking-[0.14em] text-black transition-colors hover:bg-black hover:text-white"
            >
              REDEEM CODE ↗
            </a>
          )}
        </div>
      </div>
    </Modal>
  );
}
